var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorAssets02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4bbed0;}.cls-2{fill:#fff;}.cls-3{fill:#6cb706;}.cls-4{fill:#90d12a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3-2",
    "data-name": "Ellipse 3-2",
    className: "cls-1",
    cx: 180,
    cy: 182.1,
    r: 155.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-2",
    d: "M68.7,229.4a14.4,14.4,0,0,1,4.9,5.5c1.7,3.8.4,6-2.9,7.5l-4.6,2.2c-.7.3-.9.7-.7,1.1a1.8,1.8,0,0,0,.7.8l-3.2,1.4a7,7,0,0,1-1.9-2.6,2.5,2.5,0,0,1,.6-3.5l.4-.2a6.6,6.6,0,0,1-4.4-3.4,3.9,3.9,0,0,1,1.4-5.4l.5-.2c2.5-1.2,4.3.1,6.3,2.6l1.8,2.1c.6.9,1.1,1.1,1.7.8a1.6,1.6,0,0,0,.7-2.4,9.2,9.2,0,0,0-4.5-4Zm-7.3,9.2a3.9,3.9,0,0,0,2.7,1.8l2.6-1.2-1-.7-1-1.2c-.9-.9-1.6-1.2-2.5-.8a1.4,1.4,0,0,0-.9,1.9v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "cls-2",
    d: "M90.7,253.1l2.8,3.8L76.9,269.1l-2.8-3.8,2-1.5a5.1,5.1,0,0,1-5-2.1c-2-2.7-1.6-6.5,2.7-9.6s8-2.4,10,.2a5.3,5.3,0,0,1,.7,5.4Zm-14,3c-2,1.5-2.7,3.3-1.5,4.8s3,1.4,5,0,2.7-3.4,1.6-4.9S78.8,254.6,76.7,256.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-2",
    d: "M93.9,265.6l3.9,3.6-4.1,9.2,8.8-5,3.2,3-14.6,7.2-3-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-2",
    d: "M110.4,282a14.1,14.1,0,0,1,7,1.9c3.6,2.3,3.7,4.8,1.7,7.9l-2.7,4.4c-.4.6-.4,1,0,1.3a2,2,0,0,0,1.1.2l-2,3a7.9,7.9,0,0,1-3-1.2,2.5,2.5,0,0,1-1.4-3.2c.1-.2.2-.3.2-.4a6.7,6.7,0,0,1-5.5-.6,3.8,3.8,0,0,1-1.7-5.2l.3-.5c1.4-2.3,3.7-2.2,6.7-1.2l2.6.8c1,.4,1.5.3,1.9-.3s.2-1.7-.7-2.3a9.7,9.7,0,0,0-6-1Zm-1.2,11.7a3.6,3.6,0,0,0,3.2,0l1.6-2.4a2.5,2.5,0,0,1-1.2-.1l-1.5-.4c-1.3-.3-2-.2-2.5.7a1.4,1.4,0,0,0,.2,2l.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "cls-2",
    d: "M134.3,309.1l2.8-7.4c1-2.7.4-3.9-1.1-4.5s-2.8,0-3.8,2.6l-2.8,7.5-4.5-1.7,5.4-14.2,4.4,1.7-.8,2.3a4.6,4.6,0,0,1,5.2-1c2.9,1.1,4.5,3.3,2.6,8.4l-3,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "cls-2",
    d: "M150.3,306.1c.8-4.7,4.2-7.3,8.7-6.5a8.1,8.1,0,0,1,5.5,3.5l-2.4,3.2a4.3,4.3,0,0,0-3.1-2.9c-2-.3-3.4,1.2-3.8,3.6s.5,4.2,2.3,4.5a4.8,4.8,0,0,0,4-1.3l1.1,3.5a8,8,0,0,1-6.5,1.4C151.8,314.4,149.5,310.8,150.3,306.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "cls-2",
    d: "M184.6,311.8l.8,3.5a10.6,10.6,0,0,1-6,1.8c-4.7,0-7.8-2.6-7.8-7.6s3.4-8.2,7.6-8.2,6.5,2.2,6.5,6.9a10.9,10.9,0,0,1-.1,1.8h-9.1c0,2.4,1.2,3.7,3.4,3.7A7,7,0,0,0,184.6,311.8Zm-8.2-4.4h5.4c.1-1.6-.6-3.2-2.6-3.2a3.1,3.1,0,0,0-2.9,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-2",
    d: "M206.7,313.7l-1.9-7.8c-.6-2.5-1.6-3.4-3.2-3s-2.3,1.7-1.7,4.1l1.9,7.9-4.6,1.1-3.5-14.7,4.6-1.2.5,2.4a5.1,5.1,0,0,1,9-1.9,4.7,4.7,0,0,1,4-4c3.3-.8,5.8.2,7.1,5.4l1.9,8.3-4.5,1.1-1.9-7.8c-.6-2.4-1.6-3.4-3.2-3s-2.3,1.7-1.7,4.1l1.9,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-2",
    d: "M240.6,295.6l2.4,2.7a11.4,11.4,0,0,1-4.6,4.4c-4.2,2-8.1,1.1-10.4-3.3s-.6-8.9,3.1-10.8,6.9-.9,9,3.3a8.5,8.5,0,0,1,.6,1.7l-8.1,4c1.1,2.2,2.8,2.8,4.7,1.8A6.9,6.9,0,0,0,240.6,295.6Zm-9.3-.2,4.9-2.5c-.6-1.4-2-2.6-3.8-1.7a3.1,3.1,0,0,0-1.1,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-2",
    d: "M261.1,287.6l-4.9-6.3c-1.7-2.2-3.1-2.3-4.4-1.4s-1.5,2.4.2,4.6l4.9,6.3-3.7,2.9-9.3-12,3.8-2.9,1.4,1.9a4.9,4.9,0,0,1,1.9-4.9c2.5-1.9,5.2-2.1,8.6,2.2l5.2,6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-2",
    d: "M272.6,269c.9.7,1.6,1,2.4.2a4.8,4.8,0,0,0,.7-2.9l3.2,2.9a7.5,7.5,0,0,1-2,3.7c-2.3,2.6-4.5,2.3-6.9.1l-5.4-4.9-1.6,1.8-2.3-2.1c2-2.2,2.6-3.3-.6-6.4l1.9-2.1,3.5,3.2,2.8-3.1,2.3,2.1-2.8,3.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-2",
    d: "M83.6,98a14.9,14.9,0,0,1,3.6-6.2c3-3,5.4-2.6,7.7-.3l3.3,3.3c.4.5.8.6,1.1.2a2.1,2.1,0,0,0,.6-1l2.1,2.4a8.1,8.1,0,0,1-1.8,2.6c-1.4,1.4-2.4,1.4-3.7.5a6.9,6.9,0,0,1-1.9,5.1c-1.8,1.7-4,2-5.7.3s-1-3.8.7-6.4l1.5-2.3c.6-.9.6-1.4.2-1.8s-1.5-.6-2.3.2a9.3,9.3,0,0,0-2.5,5.4Zm10.3,3.1a3.7,3.7,0,0,0,1-3L93,96.2a2.1,2.1,0,0,1-.4,1.1l-.7,1.3c-.7,1.2-.7,1.9-.1,2.5a1.4,1.4,0,0,0,2,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-2",
    d: "M105.6,70.8l3.9-2.7,10.6,15.2L116.2,86l-1.3-1.8a5.5,5.5,0,0,1-2.4,4.8c-2.7,1.9-6.4,1.5-9.1-2.4s-1.7-7.4,1-9.3a5.2,5.2,0,0,1,5.2-.8Zm1.9,13c1.3,1.8,3,2.4,4.6,1.3s1.5-2.8.2-4.7-3-2.5-4.5-1.4-1.6,2.9-.3,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-2",
    d: "M120.5,67.4l4.8-2.2,6.5,6.5-.7-9.1,3.9-1.8.3,14.9-3.7,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-2",
    d: "M144.1,59.4a16.3,16.3,0,0,1,6.3-3.5c4.1-1,5.9.5,6.7,3.7l1.1,4.5c.2.7.5.9,1,.8l.9-.5.7,3.1a13,13,0,0,1-3,1.3c-1.9.4-2.7-.1-3.3-1.5a7.2,7.2,0,0,1-4.3,3.4c-2.5.6-4.5-.3-5.1-2.6s1.1-3.8,3.9-5.2l2.5-1.2c.9-.5,1.2-.9,1.1-1.5s-1.1-1.2-2.2-.9a9.1,9.1,0,0,0-4.8,3.4Zm7.3,8a4,4,0,0,0,2.3-2.1l-.6-2.6a2.3,2.3,0,0,1-.9.8l-1.3.7c-1.2.7-1.6,1.2-1.4,2.1a1.3,1.3,0,0,0,1.6,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-2",
    d: "M178,66.3l-.3-7.2c-.1-2.5-1.2-3.3-2.8-3.2s-2.6.9-2.5,3.5l.3,7.1-4.7.2-.6-13.6,4.8-.2v2.2a4.8,4.8,0,0,1,4.4-2.7c3.1-.1,5.5,1.2,5.7,6.1l.3,7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-2",
    d: "M191.2,59.9c.6-4.2,3.9-6.6,8.4-5.8a8.4,8.4,0,0,1,5.6,3.1L203,60.1a4.7,4.7,0,0,0-3.2-2.6c-2.1-.3-3.4,1.1-3.7,3.2s.6,3.8,2.4,4.1a4.8,4.8,0,0,0,4-1.2l1.2,3.2a9,9,0,0,1-6.4,1.3C192.9,67.4,190.5,64.1,191.2,59.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-2",
    d: "M223.2,70.6l-.2,3.2a10.9,10.9,0,0,1-6.2-.6c-4.4-1.5-6.5-4.8-5-9s5.7-5.8,9.6-4.4,5.5,4.2,4.1,8.1a10.9,10.9,0,0,1-.8,1.5l-8.5-3.1a3,3,0,0,0,1.4,4l.6.3A8.5,8.5,0,0,0,223.2,70.6Zm-6.3-6.5,5.1,1.8a2.5,2.5,0,0,0-.9-3.4l-.5-.2a2.9,2.9,0,0,0-3.7,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-2",
    d: "M237.8,83.4l4.1-6c1.2-1.9,1.2-3.2-.2-4.1s-2.7-.6-4,1.3l-4,6-4-2.6,7.7-11.3,3.9,2.6-1.2,1.8c.9-.6,2.7-1.1,5.2.5a4.7,4.7,0,0,1,2.3,4.8,4.8,4.8,0,0,1,5.4.4c2.9,2,3.9,4.4,1.3,8.3l-4.4,6.5L246,88.9l4.1-6c1.2-1.9,1.2-3.1-.2-4.1s-2.7-.5-4,1.3l-4,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-2",
    d: "M267.2,103.4l-1.7,2.7a10.4,10.4,0,0,1-5.3-3.4c-3.2-3.4-3.6-7.2-.3-10.2s7.8-2.6,10.6.5,3,6.2-.1,9a7.1,7.1,0,0,1-1.4,1l-6.1-6.7a3.1,3.1,0,0,0-.7,4.2l.5.5A8,8,0,0,0,267.2,103.4Zm-2.7-8.7,3.7,4a2.5,2.5,0,0,0,.8-3.4,1,1,0,0,0-.4-.5,2.7,2.7,0,0,0-4-.2.1.1,0,0,0-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-2",
    d: "M274.6,121.8l6.1-3.8c2.2-1.4,2.3-2.7,1.5-4s-2.1-1.8-4.3-.5l-6,3.9-2.6-4.1,11.6-7.2,2.5,4-1.8,1.2a4.8,4.8,0,0,1,4.5,2.5c1.6,2.6,1.7,5.3-2.5,7.9l-6.4,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-2",
    d: "M287.6,136.6c-.9.4-1.4,1-1,1.9a4.1,4.1,0,0,0,2.2,1.9l-3.6,1.6a9.2,9.2,0,0,1-2.4-3.4c-1.4-3.1-.4-5,2.3-6.1l6.1-2.6-1-2.2,2.6-1.1c1.1,2.7,1.9,3.7,5.6,2.3l1.1,2.6-3.9,1.7,1.6,3.8-2.5,1.1-1.7-3.8Z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    className: "cls-2",
    cx: 178.9,
    cy: 182.3,
    r: 95.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-3",
    d: "M186.7,133.4l-46.2,43.8L217,189.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    className: "cls-4",
    x: 150.7,
    y: 190.8,
    width: 48.6,
    height: 32.92,
    transform: "translate(-57.1 347.6) rotate(-81)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorAssets02);
export default __webpack_public_path__ + "static/media/Vector Assets-02.190896d0a4c4c567dbf260663adcd7ce.svg";
export { ForwardRef as ReactComponent };